import React from 'react';
import { Typography, List, ListItem, ListItemText, Divider } from '@mui/material';

const DataStorageInfo: React.FC = () => {
  return (
    <div>
      <Typography variant="h4" gutterBottom>
        6. Tempo de Armazenamento de Dados
      </Typography>

      <Typography paragraph>
        Seus dados pessoais coletados serão utilizados e armazenados durante o tempo necessário para a prestação do serviço ou para que as finalidades elencadas na presente Política sejam atingidas, considerando os direitos dos titulares dos dados e dos controladores.
      </Typography>

      <Typography paragraph>
        De modo geral, seus dados serão mantidos enquanto a relação contratual entre você e a INNOVA PLANO DE SAÚDE perdurar. Findado o período de armazenamento dos dados pessoais, estes serão excluídos de nossas bases de dados ou anonimizados, ressalvadas as hipóteses legalmente previstas no artigo 16 da Lei Geral de Proteção de Dados, a saber:
      </Typography>

      <List>
        <ListItem>
          <ListItemText
            primary="I – Cumprimento de obrigação legal ou regulatória pelo controlador"
          />
        </ListItem>
        <ListItem>
          <ListItemText
            primary="II – Estudo por órgão de pesquisa, garantida, sempre que possível, a anonimização dos dados pessoais"
          />
        </ListItem>
        <ListItem>
          <ListItemText
            primary="III – Transferência a terceiro, desde que respeitados os requisitos de tratamento de dados dispostos nesta Lei"
          />
        </ListItem>
        <ListItem>
          <ListItemText
            primary="IV – Uso exclusivo do controlador, vedado seu acesso por terceiro, e desde que anonimizados os dados"
          />
        </ListItem>
      </List>

      <Typography paragraph>
        As informações pessoais sobre você que sejam imprescindíveis para o cumprimento de determinações legais, judiciais e administrativas e/ou para o exercício do direito de defesa em processos judiciais e administrativos serão mantidas, a despeito da exclusão dos demais dados.
      </Typography>

      <Typography paragraph>
        O armazenamento de dados coletados pela INNOVA PLANO DE SAÚDE reflete o nosso compromisso com a segurança e a privacidade dos mesmos. Empregamos medidas e soluções administrativas e técnicas de proteção para garantir a confidencialidade, integridade e inviolabilidade dos seus dados. Além disso, contamos com medidas de segurança apropriadas aos riscos e com controle de acesso às informações armazenadas.
      </Typography>
    </div>
  );
};

export default DataStorageInfo;
